<template>
    <section class="newsletter-confirm">
        <template v-if="errorMessage">
            <b-alert variant="danger" show>{{errorMessage}}</b-alert>
        </template>
        <template v-else>
            <template v-if="processing">
                <CenteredMessage>
                    <template #title>Kontakte werden übertragen...</template>
                    {{processMessage}}
                    <b-progress :value="formattedProcessValue" :max="100" class="w-25 mx-auto mt-3"></b-progress>
                </CenteredMessage>
            </template>
            <template v-else>
                <CenteredMessage>
                    <template #title>Kontakte erfolgreich übertragen</template>
                    Die ausgewählten Kontakte wurden als Empfänger für die nächste Newsletterversendung übertragen
                    <b-button
                        variant="primary"
                        block
                        :href="editUrl"
                        target="_blank"
                        class="w-25 mx-auto mt-3"
                    >Direkt zum Newsletter</b-button>
                </CenteredMessage>
            </template>
        </template>
    </section>
</template>

<script>
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
export default {
    name: "NewsletterConfirm",
    components: {
        CenteredMessage
    },
    props: [
        "processing",
        "processMessage",
        "processValue",
        "errorMessage",
        "editUrl"
    ],
    computed: {
        formattedProcessValue() {
            return Number(this.processValue);
        }
    }
};
</script>